module.exports = __webpack_public_path__ + "static/fonts/Fact-Italic.f356a27.woff2";